
export default {
    // web3: {
    //     provider: {
    //         ETH: "https://kovan.infura.io/v3/a7ffb097e724456bbe2b712160f25c4c",
    //         ETSC: "http://54.180.106.164:8585",
    //     },
    // },
    // etherscan: {
    //     url: "https://api-kovan.etherscan.io/api",
    //     key: '1BD5CX2NPE4QCDDFEZU6F61NDM9TQ6ND16'
    // },
    web3: {
        provider: {
            ETH: "https://kovan.infura.io/v3/a7ffb097e724456bbe2b712160f25c4c",
            ETSC: "http://api.etscscan.io/rpc",
        },
    },
    etherscan: {
        url: "https://api.etherscan.io/api",
        key: '1BD5CX2NPE4QCDDFEZU6F61NDM9TQ6ND16'
    },
    sicbo: {
        address: "0x80f1b85d297e2ad3f76c99f1059f13670c13243b",
        abi: [
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "_eth",
                        "type": "uint256[]"
                    }
                ],
                "name": "buy",
                "outputs": [],
                "payable": true,
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [],
                "name": "doDevIn",
                "outputs": [],
                "payable": true,
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "_eth",
                        "type": "uint256"
                    }
                ],
                "name": "doDevOut",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "_devAddr",
                        "type": "address"
                    }
                ],
                "name": "setDevs",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "time",
                        "type": "uint256"
                    }
                ],
                "name": "setGameTime",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "_price",
                        "type": "uint256"
                    }
                ],
                "name": "setPrice",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "constant": false,
                "inputs": [
                    {
                        "name": "_rID",
                        "type": "uint256"
                    }
                ],
                "name": "withdraw",
                "outputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "payable": false,
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "payable": true,
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "name": "playerID",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "name": "playerAddress",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "name": "playerName",
                        "type": "bytes32"
                    },
                    {
                        "indexed": false,
                        "name": "isNewPlayer",
                        "type": "bool"
                    },
                    {
                        "indexed": false,
                        "name": "affiliateID",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "name": "affiliateAddress",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "name": "affiliateName",
                        "type": "bytes32"
                    },
                    {
                        "indexed": false,
                        "name": "amountPaid",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "name": "timeStamp",
                        "type": "uint256"
                    }
                ],
                "name": "onNewName",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "name": "eth",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "name": "pID",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "name": "type_",
                        "type": "uint256"
                    }
                ],
                "name": "onEndTx",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "name": "playerID",
                        "type": "uint256"
                    },
                    {
                        "indexed": true,
                        "name": "roundID",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "name": "win",
                        "type": "uint256"
                    }
                ],
                "name": "onGetWin",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "name": "playerID",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "name": "playerAddress",
                        "type": "address"
                    },
                    {
                        "indexed": false,
                        "name": "playerName",
                        "type": "bytes32"
                    },
                    {
                        "indexed": false,
                        "name": "ethOut",
                        "type": "uint256"
                    },
                    {
                        "indexed": false,
                        "name": "timeStamp",
                        "type": "uint256"
                    }
                ],
                "name": "onWithdraw",
                "type": "event"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "devAddr_",
                "outputs": [
                    {
                        "name": "",
                        "type": "address"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "devIn_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "devOut_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "gameTime_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "_addr",
                        "type": "address"
                    }
                ],
                "name": "getPlayerInfoByAddress",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    },
                    {
                        "name": "",
                        "type": "uint256"
                    },
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "invest_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    },
                    {
                        "name": "",
                        "type": "uint256"
                    },
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "numPlyr_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "pID_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "pIDxAddr_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "plyr_",
                "outputs": [
                    {
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "name": "withdraw",
                        "type": "uint256"
                    },
                    {
                        "name": "eth",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    },
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "plyrRound_",
                "outputs": [
                    {
                        "name": "big",
                        "type": "uint256"
                    },
                    {
                        "name": "small",
                        "type": "uint256"
                    },
                    {
                        "name": "same",
                        "type": "uint256"
                    },
                    {
                        "name": "isWithdraw",
                        "type": "bool"
                    },
                    {
                        "name": "single",
                        "type": "uint256"
                    },
                    {
                        "name": "double",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "price_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "rID_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "round_",
                "outputs": [
                    {
                        "name": "strt",
                        "type": "uint256"
                    },
                    {
                        "name": "ended",
                        "type": "uint256"
                    },
                    {
                        "name": "big",
                        "type": "uint256"
                    },
                    {
                        "name": "small",
                        "type": "uint256"
                    },
                    {
                        "name": "same",
                        "type": "uint256"
                    },
                    {
                        "name": "res",
                        "type": "uint256"
                    },
                    {
                        "name": "single",
                        "type": "uint256"
                    },
                    {
                        "name": "double",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [],
                "name": "win_",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            },
            {
                "constant": true,
                "inputs": [
                    {
                        "name": "_rID",
                        "type": "uint256"
                    },
                    {
                        "name": "_num",
                        "type": "uint256"
                    }
                ],
                "name": "WinnerLength",
                "outputs": [
                    {
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "payable": false,
                "stateMutability": "view",
                "type": "function"
            }
        ]
    }
};